import type { ReactNode } from 'react';
import { UpdateBanner } from '../../components/UpdateBanner';
import { Logo, LogoMark } from '../../layout/Logo';

/** Экран входа: слева знак-визир крупно, справа форма. На телефоне — форма под логотипом. */
export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col">
      {/* Обновление портала видно и до входа: человек не начнёт работу за минуту до выкладки */}
      <UpdateBanner variant="auth" />
      <div className="grid flex-1 lg:grid-cols-[minmax(420px,1fr)_minmax(480px,1fr)]">
        <aside className="relative hidden flex-col justify-between overflow-hidden bg-nav-bg p-12 text-white lg:flex">
          <Logo height={30} className="text-white" />
          <div className="relative">
            <LogoMark size={260} className="text-white/90" />
            <p className="mt-10 max-w-md text-[22px] leading-8 font-medium tracking-[-0.01em]">
              Смета, график, закупки, договоры и площадка — в одной системе, где маржа объекта считается от
              сметы до факта.
            </p>
          </div>
          <p className="text-[13px] text-nav-muted">Портал управления строительными EPC-проектами</p>
        </aside>
        <main className="flex flex-col items-center justify-center px-5 py-10 sm:px-10">
          <div className="w-full max-w-[400px]">
            <Logo height={26} className="mb-10 text-ink lg:hidden" />
            <h1 className="text-[24px] leading-8 font-semibold tracking-[-0.01em] text-ink">{title}</h1>
            {subtitle ? <div className="mt-2 text-[14px] text-ink-2">{subtitle}</div> : null}
            <div className="mt-8">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
}
